import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    EditButton,
    Edit,
    Create,
    SimpleForm,
    TextInput,
    SelectInput,
    BooleanInput,
    DateTimeInput,
    DateField,
    Filter,
    ReferenceInput,
    ReferenceField,
    DeleteButton,
} from 'react-admin';

const SurveyFilter = (props) => (
    <Filter {...props}>
        <TextInput label="搜索标题" source="key" alwaysOn />
        <SelectInput source="Type" label="类型" choices={[
            { id: 'course', name: '课程评价' },
            { id: 'teacher', name: '师资评价' },
            { id: 'platform', name: '平台体验' },
        ]} />
        <SelectInput source="Status" label="状态" choices={[
            { id: 1, name: '已发布' },
            { id: 0, name: '草稿' },
            { id: 2, name: '已结束' },
        ]} />
    </Filter>
);

export const SurveyList = props => (
    <List {...props} filters={<SurveyFilter />} title="问卷管理">
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="Title" label="问卷标题" />
            <TextField source="Type" label="类型" />
            <ReferenceField source="CourseId" reference="Admin/CMSCourse" label="关联课程" allowEmpty>
                <TextField source="Title" />
            </ReferenceField>
            <TextField source="QuestionCount" label="题目数" />
            <TextField source="AnswerCount" label="回答数" />
            <TextField source="IsAnonymous" label="匿名" />
            <TextField source="Status" label="状态" />
            <DateField source="CreateTime" label="创建时间" showTime />
            <EditButton />
            <DeleteButton />
        </Datagrid>
    </List>
);

export const SurveyEdit = props => (
    <Edit {...props} title="编辑问卷">
        <SimpleForm>
            <TextInput disabled source="id" />
            <TextInput source="Title" label="问卷标题" fullWidth />
            <TextInput source="Description" label="问卷描述" multiline fullWidth />
            <ReferenceInput source="CourseId" reference="Admin/CMSCourse" label="关联课程" allowEmpty>
                <SelectInput optionText="Title" />
            </ReferenceInput>
            <SelectInput source="Type" label="类型" choices={[
                { id: 'course', name: '课程评价' },
                { id: 'teacher', name: '师资评价' },
                { id: 'platform', name: '平台体验' },
            ]} />
            <BooleanInput source="IsAnonymous" label="允许匿名" />
            <DateTimeInput source="StartTime" label="开始时间" />
            <DateTimeInput source="EndTime" label="结束时间" />
            <SelectInput source="Status" label="状态" choices={[
                { id: 1, name: '已发布' },
                { id: 0, name: '草稿' },
                { id: 2, name: '已结束' },
            ]} />
        </SimpleForm>
    </Edit>
);

export const SurveyCreate = props => (
    <Create {...props} title="新建问卷">
        <SimpleForm>
            <TextInput source="Title" label="问卷标题" fullWidth />
            <TextInput source="Description" label="问卷描述" multiline fullWidth />
            <ReferenceInput source="CourseId" reference="Admin/CMSCourse" label="关联课程" allowEmpty>
                <SelectInput optionText="Title" />
            </ReferenceInput>
            <SelectInput source="Type" label="类型" defaultValue="course" choices={[
                { id: 'course', name: '课程评价' },
                { id: 'teacher', name: '师资评价' },
                { id: 'platform', name: '平台体验' },
            ]} />
            <BooleanInput source="IsAnonymous" label="允许匿名" defaultValue={true} />
            <DateTimeInput source="StartTime" label="开始时间" />
            <DateTimeInput source="EndTime" label="结束时间" />
            <SelectInput source="Status" label="状态" defaultValue={0} choices={[
                { id: 1, name: '已发布' },
                { id: 0, name: '草稿' },
            ]} />
        </SimpleForm>
    </Create>
);
